import { useQuery } from '@tanstack/react-query';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';

const fetchCountryPreferences = async (): Promise<number[]> => preferencesApi.getCountriesSettings();

export const useCountryPreferencesQuery = () => {
  return useQuery<number[]>({
    queryKey: preferencesQueryKey.countries(),
    queryFn: fetchCountryPreferences,
  });
};

export type CountryPreferencesQuery = ReturnType<typeof useCountryPreferencesQuery>;
